import { Button, Card, DatePicker, Form, message, Select } from "antd";
import { GET_SEWING_LINE_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isSuperAdmin } from "utils/functions";

export default function AppDashboardLine() {
  const [options, setOptions] = useState([]);
  const navigate = useNavigate();
  const superAdmin = isSuperAdmin();

  const onFinish = (values) => {
    const formattedDate = values.date
      ? moment(values.date).format("YYYY-MM-DD")
      : null;

    const queryParams = new URLSearchParams({ without_layout: "true" });
    if (formattedDate) {
      queryParams.set("date", formattedDate);
    }

    navigate(
      `/digitalization/app-dashboard/${values.line.join(
        ",",
      )}?${queryParams.toString()}`,
    );
  };

  const getAllLines = async (filterValues) => {
    const query = `${GET_SEWING_LINE_ENDPOINT}`;
    const payload = {
      ...filterValues,
    };

    const response = await getData(query, false, payload);
    if (response?.status === 200) {
      setOptions(
        response.data?.data?.data?.map((line) => ({
          value: line.id,
          label: line.name,
        })),
      );
    } else {
      message.error("Error getting warehouse data");
    }
  };

  useEffect(() => {
    getAllLines();
  }, []);

  return (
    <Card
      style={{
        margin: "20px",
        padding: "20px",
      }}
    >
      <Form onFinish={onFinish} layout="vertical">
        <Form.Item
          label="Line"
          name="line"
          rules={[
            {
              required: true,
              message: "Please select line",
            },
          ]}
        >
          <Select
            mode="multiple"
            showSearch
            filterOption={false}
            placeholder="Select line"
            onSearch={(value) => {
              getAllLines({ name: value });
            }}
          >
            {options.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {superAdmin && (
          <Form.Item label="Date" name="date">
            <DatePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              placeholder="Select date"
            />
          </Form.Item>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}
